'use client';
import { WaitlistForm } from '@/components/waitlist/waitlist-form';
import { SectionHeading } from './section-heading';
import { AppStoreBadges } from './app-store-badges';

export function LandingWaitlist() {
  return (
    <section
      id="waitlist"
      className="scroll-mt-24 bg-[#cdc4c1] px-5 py-20 md:px-10 md:py-28 lg:px-22 4xl:px-50"
    >
      <div className="mx-auto max-w-2xl">
        <SectionHeading
          centered
          title="Join the waitlist."
          description="Founding membership is limited. Wee Amici is Houston's premium parent community — built for the parents who want member-recommended resources, first-hand recommendations, and a tight-knit network. Founding members get locked-in pricing and early access."
          className="mb-12"
        />

        <WaitlistForm />

        {/* Highest-intent spot on the page: someone who just signed up is the
            person most likely to want the app. */}
        <AppStoreBadges
          centered
          label="Take Wee Amici with you"
          className="mt-14 border-t border-[#948780]/40 pt-12"
        />
      </div>
    </section>
  );
}
